module.exports = __webpack_public_path__ + "img/p-icon8.a8ed9d27.png";